import CollectionLog from "./CollectionLog.vue";
export default CollectionLog;
